export default __webpack_public_path__ + "4c1d970570e00ae50179f464b8053dbb.svg";